import { render, staticRenderFns } from "./gongyuDetail.vue?vue&type=template&id=90fa6598&scoped=true&"
import script from "./gongyuDetail.vue?vue&type=script&lang=js&"
export * from "./gongyuDetail.vue?vue&type=script&lang=js&"
import style0 from "./gongyuDetail.vue?vue&type=style&index=0&id=90fa6598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fa6598",
  null
  
)

export default component.exports